// components/HeroCarousel.js
import React from 'react';
import { Carousel } from 'react-bootstrap';
import '../components/HeroCarousel.css';

function HeroCarousel() {
  return (
    <Carousel className="hero-carousel">
      <Carousel.Item>
        <div 
          className="carousel-image"
          style={{backgroundImage: `url("https://cdn.pixabay.com/photo/2015/05/28/14/53/ux-788002_1280.jpg")`}}
        />
        <Carousel.Caption>
          <h3>App Development</h3>
          <p>We create cutting-edge mobile applications for your business.</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <div 
          className="carousel-image"
          style={{backgroundImage: `url("https://cdn.pixabay.com/photo/2021/10/11/17/37/smartphone-6701409_1280.jpg")`}}
        />
        <Carousel.Caption>
          <h3>Web Solutions</h3>
          <p>Custom web applications tailored to your needs.</p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default HeroCarousel;